import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class OTextArea extends Component {
  constructor(props) {
    super(props);
    this.state = { editorHtml: EditorState.createEmpty() }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.setState({ editorHtml: value });
    if (this.props.onChange) {
      this.props.onChange(draftToHtml(convertToRaw(value.getCurrentContent())), this.props.qid);
    }
  }

  componentWillMount() {
    this.initData(this.props.defaultValue);
  }

  componentWillReceiveProps(props) {
    if (this.props.visible !== props.visible && props.visible === true) {
      this.initData(props.defaultValue);
    }
  }

  initData = (value) => {
    console.log('defaultValue::', value);
    if (value) {
      const contentBlock = htmlToDraft(value);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        this.state = {
          editorHtml: editorState,
        };
      }
    }
    else {
      this.state = {
        editorHtml: EditorState.createEmpty()
      };
    }
  }

  render() {
    const { defaultValue } = this.props;
    //console.log('props.defaultValue::', defaultValue);
    return (
      <Editor
        editorState={this.state.editorHtml}
        onEditorStateChange={this.handleChange}
        toolbar={{
          options: ['fontSize', 'emoji', 'textAlign', 'list'],
          list: { inDropdown: false },
          textAlign: { inDropdown: false },
          link: { inDropdown: false },
          history: { inDropdown: false },
        }}
      />
    )
  }
}

export default OTextArea;


// WEBPACK FOOTER //
// ./src/components/common/TextArea/index.js